import React from "react";
import Cards from "./Cards";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import BaseURL from "../Util/BaseURL";

const GetSingleProduct = ({ data }) => {
  const [product, setProduct] = useState([]);

  const getsp = async () => {
    const response = await axios.get(`${BaseURL}getProduct?id=${data}`, {
      headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") },
    });
    setProduct(response.data);
  };
  useEffect(() => {
    getsp();
  }, []);

  return (
    <>
      <Cards data={product} />
    </>
  );
};

export default GetSingleProduct;
